import {Control} from 'ol/control';
import {HintOptions} from "../configuration/control";

class HintControl extends Control {
    
    private visible;
    private readonly legendBox;
    private readonly questionWrapper;
    private readonly questionButton;
    private readonly legendBoxDetail;
    
    constructor(options: HintOptions) {
        const element = document.createElement('div');
        element.className = 'cfm-tool cfm-hint ol-unselectable ol-control';

        super({
            element: element,
            target: options.target,
        });

        this.visible = options.visible;

        const toggleHide = () => {
            this.visible = !this.visible;
            this.legendBox.className = this.visible ? '' : 'closed';
        }

        this.legendBox = document.createElement('div');
        this.legendBox.id = 'legend-box';
        this.legendBox.className = this.visible ? '' : 'closed';

        this.questionWrapper = document.createElement('div');
        this.questionWrapper.className = "question-btn-wrapper arrow left";
        this.legendBox.appendChild(this.questionWrapper);

        this.questionButton = document.createElement('div');
        this.questionButton.className = "question-btn";
        this.questionButton.innerHTML = '<i class="fal fa-question-circle"></i>';
        this.questionWrapper.appendChild(this.questionButton);

        this.questionButton.addEventListener('click', toggleHide, false);

        this.legendBoxDetail = document.createElement('div');
        this.legendBoxDetail.className = "legend-box-detail";
        this.legendBox.appendChild(this.legendBoxDetail);

        options.entries.forEach(entry => {
            const item = document.createElement('div');
            item.className = "legend-box-detail-item";

            const icon = document.createElement('i');
            icon.className = "fas " + entry.icon;
            icon.setAttribute('style', "color:" + entry.color + ";");

            item.appendChild(icon);

            item.append(' ');
            item.append(entry.title);

            this.legendBoxDetail.appendChild(item);
        })



        element.appendChild(this.legendBox);
    }
}

export default HintControl;